const STATUS = {
  NEW: "new",
  INPROGRESS: "in-progress",
  ACTIVE: "active",
  DECLINE: "decline",
  NOTIFICATION: "notification",
  SEARCH: "search",
};
export default STATUS;
